import { ConversationContainer } from '@opsbase/web-conversation-views';
import Dialog from '@opsbase/web-dialogs/Dialog';
import DialogSize from '@opsbase/web-dialogs/Dialog/DialogSize';
import useParams from '@opsbase/web-nav/useParams';
import Spinner from '@opsbase/web-ui/Spinner';
import React, { useMemo } from 'react';
export function ConversationDialog() {
    const { id, title } = useParams();
    const content = useMemo(() => {
        return React.createElement(ConversationContainer, { id: id, title: title });
    }, [id, title]);
    return (React.createElement(Dialog, { size: DialogSize.X1000_Y500 },
        React.createElement(Spinner, null, () => content)));
}
export default ConversationDialog;
